export const tutorialCollections = [
  {
    id: 'tutorial-1',
    label: 'Tutorial 1',
    cardTitle: 'Tu primer símbolo',
    description: 'Identifica el área iluminada y arrastra tu primer símbolo desde la librería.',
    accent: 'linear-gradient(135deg, #d6e6ff 0%, #f3f8ff 100%)',
    thumbnail: '/assets/tutoriales/arrastraPrimerSimbolo/portada-primer-simbolo-1.jpg',
    slides: [
      {
        id: 'drag-symbol',
        title: 'Arrastra tu primer símbolo',
        image: '/assets/tutoriales/arrastraPrimerSimbolo/primer-simbolo-1.jpg',
        paragraphs: [
          'La zona que se ilumina es tu área de trabajo. Solo necesitas arrastrar cualquier símbolo desde la librería hacia esa área.',
          'Si deseas crear una nueva página, simplemente arrastra un símbolo fuera del área de trabajo.',
        ],
      },
      {
        id: 'connect-symbols',
        title: 'Conecta tus símbolos',
        image: '/assets/tutoriales/arrastraPrimerSimbolo/primer-simbolo-2.jpg',
        paragraphs: [
          'Puedes conectar componentes de dos formas:',
          '• Arrastrando directamente desde un punto del símbolo al otro.',
          '• Dibujando tus propias líneas para un control más preciso.',
        ],
      },
      {
        id: 'align-lines',
        title: 'Ajusta tus líneas sobre la cuadrícula',
        image: '/assets/tutoriales/arrastraPrimerSimbolo/primer-simbolo-3.jpg',
        paragraphs: [
          'Al seleccionar una línea podrás reubicarla siguiendo la cuadrícula para mantener tu diagrama limpio y alineado.',
        ],
      },
      {
        id: 'edit-symbols',
        title: 'Modifica tus símbolos',
        image: '/assets/tutoriales/arrastraPrimerSimbolo/primer-simbolo-4.jpg',
        paragraphs: [
          'Selecciona cualquier símbolo para rotarlo, clonarlo, cambiar su color o editar sus propiedades.',
        ],
      },
    ],
  },
  {
    id: 'tutorial-2',
    label: 'Tutorial 2',
    cardTitle: 'Domina los inspectores',
    description: 'Edita la información técnica y visual de cada componente con precisión.',
    accent: 'linear-gradient(135deg, #ffe5d4 0%, #fff6ee 100%)',
    thumbnail: '/assets/tutoriales/t2-dominaInspectores/portada-segundo-inspectores-2.jpg',
    slides: [
      {
        id: 'inspector-overview',
        title: 'Paso 1 · Inspector técnico',
        image: '/assets/tutoriales/t2-dominaInspectores/domina-inspectores-1.jpg',
        paragraphs: [
          'En SoloLine diseñamos una interfaz pensada para la simplicidad.',
          'Al presionar un nodo, se abrirá el inspector del componente, donde podrás agregar o editar sus características técnicas (como potencia, calibre o tipo de conexión).',
        ],
      },
      {
        id: 'visual-inspector',
        title: 'Paso 2 · Inspector visual',
        image: '/assets/tutoriales/t2-dominaInspectores/domina-inspectores-2.jpg',
        paragraphs: [
          'Si seleccionas el componente completo, en la parte superior aparecerá su inspector visual.',
          'Desde ahí podrás cambiar el color, tamaño de texto e ícono, y también ajustar la posición del texto asociado.',
        ],
      },
      {
        id: 'inspector-explore',
        title: 'Paso 3 · Explora opciones',
        image: '/assets/tutoriales/t2-dominaInspectores/domina-inspectores-3.jpg',
        paragraphs: [
          'Explora las opciones disponibles en cada inspector.',
          'Algunos componentes tienen propiedades únicas o configuraciones especiales, así que tómate un momento para familiarizarte con ellas.',
        ],
      },
      {
        id: 'inspector-experiment',
        title: 'Paso 4 · Experimenta libremente',
        image: '/assets/tutoriales/t2-dominaInspectores/domina-inspectores-4.jpg',
        paragraphs: [
          'Los inspectores están diseñados para ayudarte a personalizar tu diagrama con precisión y estilo, manteniendo siempre la claridad visual de tu área de trabajo.',
        ],
      },
    ],
  },
  {
    id: 'tutorial-3',
    label: 'Tutorial 3',
    cardTitle: 'Tamaños y exportación',
    description: 'Configura el formato correcto y genera archivos profesionales en minutos.',
    accent: 'linear-gradient(135deg, #d9f7f0 0%, #f1fffb 100%)',
    thumbnail: '/assets/tutoriales/t3-TamanoPlantill/portada-exportar.jpg',
    slides: [
      {
        id: 'page-sizes',
        title: 'Paso 1 · Define el tamaño de hoja',
        image: '/assets/tutoriales/t3-TamanoPlantill/exportar-tamano-1.jpg',
        paragraphs: [
          'En la barra de menú, encontrarás las opciones de tamaño de hoja disponibles en SoloLine: A4, A3 y Arch D.',
          'Al seleccionar una, aparecerán líneas guía que te muestran el área exacta de trabajo para ese formato.',
        ],
      },
      {
        id: 'export-button',
        title: 'Paso 2 · Abre el menú Exportar',
        image: '/assets/tutoriales/t3-TamanoPlantill/exportar-tamano-2.jpg',
        paragraphs: [
          'En el menú superior, haz clic en el botón Exportar.',
          'Desde ahí podrás elegir entre los formatos JPG, PNG o DXF (actualmente en desarrollo).',
        ],
      },
      {
        id: 'prepare-template',
        title: 'Paso 3 · Ajusta plantilla y márgenes',
        image: '/assets/tutoriales/t3-TamanoPlantill/exportar-tamano-3.jpg',
        paragraphs: [
          'Antes de exportar, asegúrate de agregar márgenes, imágenes o cualquier elemento adicional desde el creador de plantillas.',
          'Esto te permitirá mantener una presentación profesional y ordenada.',
        ],
      },
    ],
  },
];
